import { render, staticRenderFns } from "./PolimixProductionOrderForm.vue?vue&type=template&id=6d541b26&"
import script from "./PolimixProductionOrderForm.vue?vue&type=script&lang=js&"
export * from "./PolimixProductionOrderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports